
import SceneObject from "../scene/sceneobject";
import {getSoundOutput} from "./audio-output";
import type {SoundCategory} from "./audio-settings";
export default class SoundService 
{
    context:AudioContext;
    listener:SceneObject | null = null;
    /** Explicitly pass "music" for music; all existing effects default to "sfx". */
    output(category:SoundCategory="sfx"):GainNode{return getSoundOutput(this.context,category);}
    
    constructor()
    {
        this.context  = new (window.AudioContext || (window as any).webkitAudioContext)();

    }

    /** Call directly inside a user gesture, before any await. Emits no sound. */
    unlockFromGesture(): Promise<boolean>
    {
        try
        {
            const context = this.context;
            if(context.state === "running") return Promise.resolve(true);
            if(context.state === "closed") return Promise.resolve(false);
            // Invoke resume NOW (also covers mobile "interrupted"), not in a
            // microtask. Do not cache success: mobile can suspend again later.
            return Promise.resolve(context.resume())
                .then(() => context.state === "running")
                .catch(() => false);
        }
        catch
        {
            return Promise.resolve(false);
        }
    }

    //any SceneObject can be a listener
    set_listener(InListener:SceneObject):void
    {
        this.listener = InListener;
        this.tick_listener();
    }

     tick_listener()
     {
        if(this.listener)
        {
            const audio_listener: AudioListener = this.context.listener;
            audio_listener.positionX.setValueAtTime(this.listener.transform.position[0], this.context.currentTime);
            audio_listener.positionY.setValueAtTime(this.listener.transform.position[1], this.context.currentTime);
            audio_listener.positionZ.setValueAtTime(this.listener.transform.position[2], this.context.currentTime);
        }
     }

     tick(delta_time: number):void
     {
         this.tick_listener();
     }
}
